/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3de74161"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__